import React from 'react';
import styled from 'styled-components';
import {Typography} from '@fupa/fupa-uikit';

const SubTitle = styled(Typography)`
  display: block;
  margin: 1rem 0;
`;

const NotFoundPage = () => {
  // Id used to check in renderer.js if component is rendered for SSR
  return (
    <div id='not-found-page'>
      <Typography variant='display1'>Hoppla...‍</Typography>
      <SubTitle variant='headline2'>…wir konnten die angefragte Seite nicht finden. ⚽🤷🤷‍♂️</SubTitle>
    </div>
  );
};

export default NotFoundPage;
